import React from 'react';

const WizardStep = ({ icon, text, status }) => {
  return (
    <div className={`wizard-step ${status}`}>
      <div className="icon-container">{icon}</div>
      <div className="text-container">{text}</div>
    </div>
  );
};

export default WizardStep;
